export function pickFirstTechnicalSheetPage(pages) {
  return Array.isArray(pages) ? pages[0] || null : null;
}
